<template>
    <div>
        <b-card class="standardpage reports">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="3" class="text-sm-left pt-1">
                        <i :class="suppliers.icon" class="mr-1"></i>
                        <span>{{ suppliers.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">

                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm" class="mb-0">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <span style="padding-top: 0.3em" class="text-primary"
                                            id="blaclike-tooltip">Like</span>
                                        <b-form-checkbox id="blaclike" v-model="blaclike_visible" class="z-0">
                                        </b-form-checkbox>
                                    </b-input-group>
                                    <b-input-group v-if="!blaclike_visible">
                                        <treeselect placeholder="Select blac..."
                                            searchPromptText="Type at least 3 chars..." v-model="blac" :multiple="true"
                                            :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                            :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-input-group>
                                </b-form-group>
                                <b-input-group v-if="blaclike_visible">
                                    <b-form-input v-model="blaclike" :debounce="suppliers.debounce"
                                        placeholder="Supplier BL A/C (LIKE %)" trim></b-form-input>
                                    <b-input-group-append>
                                        <b-button size="sm" variant="outline-secondary" :disabled="!blaclike"
                                            @click="blaclike = ''">
                                            <i class="fa fa-remove"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Trading Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="shortname" :debounce="suppliers.debounce"
                                            placeholder="Trading Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!shortname"
                                                @click="shortname = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Legal Entity Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="name" :debounce="suppliers.debounce"
                                            placeholder="Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!name"
                                                @click="name = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Active?" label-for="active" label-cols="12">
                                    <treeselect instanceId="active" type="number" v-model="active" :clearable="true"
                                        :options="active_options"></treeselect>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Supplier Type" label-size="sm">
                                    <treeselect instanceId="suppliertypeid" type="number" v-model="suppliertypeid"
                                        :clearable="true" :options="suppliertype_options" :multiple="true"></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Onstop?" label-for="onstop" label-cols="12">
                                    <treeselect instanceId="onstop" type="number" v-model="onstop" :clearable="true"
                                        :options="onstop_options"></treeselect>
                                </b-form-group>
                            </b-col>
                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Relevance" label-size="sm">
                    <treeselect
                      id="bl-query"
                      placeholder="Relevance query..."
                      :clearable="false"
                      v-model="query"
                      :options="query_options"
                      :disable-branch-nodes="true"
                      :show-count="true"
                      :default-expand-level="1"
                    />
                  </b-form-group>
                  <b-tooltip target="bl-query1" triggers="hover"
                    >Explain query...</b-tooltip
                  >
                </b-col> -->
                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="suppliers" :icon="suppliers.icon"
                        :busy="suppliers.busy" :toolbarlibrary="suppliers.toolbarlibrary" :tools="suppliers.tools"
                        :badges="suppliers.badges" :fields="suppliers.fields" :items="suppliers.items"
                        :offset="suppliers.offset" :limit="suppliers.limit" :downloaded="suppliers.downloaded"
                        :page="suppliers.page" @load="suppliers_load" @click="suppliers_click"
                        @changed="suppliers_click('save', $event)" @select="suppliers_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="suppliers.selected"
                    :config="suppliers.action ? { action: suppliers.action } : {}"
                    @discard="suppliers_click('discard')">
                </component>
            </div>

            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>
            </b-card-footer>
        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import SupplierEdit from "./Components/Setup_SupplierEdit";

export default {
    name: "Suppliers",
    components: { SupplierEdit },
    watch: {
        async blac() {
            await this.suppliers_load(0);
        },
        async blaclike_visible() {
            if (this.blaclike_visible) {
                this.blac = []
            } else {
                this.blaclike = null
            }
            await this.suppliers_load();
        },
        async blaclike() {
            await this.suppliers_load();
        },
        async name() {
            await this.suppliers_load(0);
        },
        async shortname() {
            await this.suppliers_load(0);
        },
        async suppliertypeid() {
            await this.suppliers_load(0);
        },
        async onstop() {
            await this.suppliers_load(0);
        },
        async active() {
            await this.suppliers_load(0);
        },
        async query() {
            if (this.query == "*") {
                this.btable_items = [];
            } else {
                await this.suppliers_load(0);
            }
        },
    },
    data() {
        return {
            blac: [],
            blaclike: null,
            blaclike_visible: null,
            shortname: null,
            name: null,
            onstop: "false",
            active: "true",
            active_options: [
                {
                    id: "true",
                    label: "Yes",
                },
                {
                    id: "false",
                    label: "No",
                },
            ],
            onstop_options: [
                {
                    id: "true",
                    label: "Yes",
                },
                {
                    id: "false",
                    label: "No",
                },
            ],
            suppliertypeid: [],
            suppliertype_options: [],

            query: "recent12",
            query_options: [
                {
                    id: "*",
                    label: "All",
                },
                {
                    id: "recent12",
                    label: "Recent (within 12 months+new)",
                },
                {
                    id: "recent48",
                    label: "Older (within 48 months+new)",
                },
            ],

            suppliers: {
                title: "Suppliers",
                icon: "fa fa-industry",
                debounce: 500,
                busy: false,
                denied: [],
                page: 1,
                offset: 0,
                limit: 15,
                action: null,
                tools: "go,filter,download,clipboard,add,copy,edit,deleteconfirm",
                toolbarlibrary: [],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right text-primary w-50px",
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                    },
                    {
                        key: "suppliertypeid",
                        label: "S Type",
                        sortable: true,
                    },
                    {
                        key: "shortname",
                        label: "Trading Name",
                        sortable: true,
                    },

                    {
                        key: "name",
                        label: "Legal Entity Name",
                        sortable: true,
                    },

                    {
                        key: "vatable",
                        label: "Vatable",
                        sortable: true,
                    },
                    {
                        key: "currency",
                        label: "Currency",
                        sortable: true,
                    },
                    {
                        key: "onstop",
                        label: "Onstop",
                        sortable: true,
                    },

                    {
                        key: "active",
                        label: "Active",
                        sortable: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center w-100px",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right w-100px",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "suppliertypeid",
                        type: "pill",
                        class: "info",
                    },
                    {
                        key: "vatable",
                        type: "badge",
                        Yes: "info",
                        No: "warning",
                        formatter: (value, key, item) => {
                            if (value == false) {
                                return "No";
                            } else if (value == true) {
                                return "Yes";
                            } else {
                                return "";
                            }
                        },
                    },
                    {
                        key: "invoicetype",
                        type: "badge",
                        P: "info",
                        N: "danger",
                        E: "info",
                    },
                    {
                        key: "onstop",
                        type: "badge",
                        No: "success",
                        Yes: "danger",

                        formatter: (value, key, item) => {
                            switch (value) {
                                case true:
                                    return "Yes";
                                    break;
                                case false:
                                    return "No";
                                    break;
                                default:
                                    return value;
                            }
                        },
                    },
                    {
                        key: "active",
                        type: "badge",
                        Yes: "success",
                        No: "danger",

                        formatter: (value, key, item) => {
                            switch (value) {
                                case true:
                                    return "Yes";
                                    break;
                                case false:
                                    return "No";
                                    break;
                                default:
                                    return value;
                            }
                        },
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {

        await this.loadDDL();

        await this.suppliers_load();
    },
    methods: {
        async loadDDL() {
            console.log("loadDDL");
            // this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query suppliertypes {
                suppliertypes {
                  id
                  label
                }
              }
            `,
                });
                this.suppliertype_options = response.data.suppliertypes;
            } catch (error) {
                console.log(error);
            }

            this.busy = false;
        },
        async suppliers_load(offset, limit, page) {
            let state = this.suppliers;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                query: this.query,
                blac: this.blac.length > 0 ? this.blac.join(",") : null,
                blaclike: this.blaclike,
                shortname: this.shortname,
                name: this.name,
                onstop: this.onstop,
                active: this.active,
                // suppliertypeid: this.suppliertypeid,
                suppliertypeid:
                    this.suppliertypeid.length > 0 ? this.suppliertypeid.join(",") : null,
                dateformat: "DD/MM/YYYY",
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query suppliers(
                $limit: Int
                $offset: Int
                $query: String
                $name: String
                $shortname: String
                $blac: String
                $blaclike: String
                $suppliertypeid: String
                $onstop: String
                $active: String
                $dateformat: String     
              ) {
                suppliers(
                  limit: $limit
                  offset: $offset  
                  query: $query
                  name: $name
                  shortname: $shortname
                  blac: $blac
                  blaclike: $blaclike
                  suppliertypeid: $suppliertypeid
                  onstop: $onstop
                  active: $active
                  dateformat: $dateformat
              
                ) {
                    id
                  name
                  shortname
                  blac
                  suppliertypeid
                  eventcode
                  currency
                  vatable
                  onstop
                  active
                  created_at
                  updated_by
                  updated_at
                  rows
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE
                // if (limit == 0) {
                //     state.selected = response.data.suppliers
                // } else {
                //     state.items = []
                //     state.items = response.data.suppliers;
                // }

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.suppliers
                } else {
                    state.items = []
                    state.items = response.data.suppliers;
                }



            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async suppliers_click(a, ss) {

            let state = this.suppliers;
            state.action = null;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.suppliers_load(0, 0);
                    break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    break;
                case "go":
                    this.component = null;
                    this.suppliers_load();
                    break;
                case "add":
                case "edit":
                    this.component = "SupplierEdit";
                    break;
                case "copy":
                    state.action = "copy";
                    this.component = "SupplierEdit";
                    await this.suppliers_load(0);
                    break;
                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;
            }
        },
        async suppliers_select(ss, tools) {

            let state = this.suppliers;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "copy"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {

            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation suppliers_save(
                $rows: [Supplier_input]             
              ) {
                suppliers_save(rows: $rows) {
                    id
                  name
                  shortname
                  blac
                  suppliertypeid
                  eventcode
                  currency
                  vatable
                  onstop
                  active
                  created_at
                  updated_at
                }
              }
            `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation suppliers_delete(
                $rows: [Supplier_input]
              ) {
                suppliers_delete(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.suppliers_load(0);
        },
    },
};
</script>

<style></style>